<app-page-heading [title]="'Chep Managers'"></app-page-heading>

<section class="container summary-panel">
    <div class="row">
        <div class="col-xs-12 m-b-sm">
            <app-data-filters #dataFilters [disableSearch]="emailFilter.minLengthInvalid">
                <app-data-filter-group>
                    <app-data-filter-input
                        #emailFilter
                        [labelKey]="'user-dashboard.users.list.filters.email.label'"
                        [(model)]="filters.email"
                        [minLength]="3"
                        [helperKey]="'user-dashboard.users.list.filters.email.helper'"
                        [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>
        </div>
        <div class="col-xs-12">
            <button class="btn btn-lg btn-primary pull-left" [disabled]="!bluechatEnabled" (click)="triggerBluechatActivationForSelectedUsers()">
                Enable Bluechat for selected users
            </button>
            <button class="btn btn-primary btn-lg pull-right" (click)="goToCreateChepManager()">
                <span class="fa fa-plus"></span>
                Create Chep Manager
            </button>
            <br>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table
                        [loadPage]="loadPage"
                        [activateBluechat]="activateBluechat"
                        [bluechatMultiUserActivationSubject]="bluechatMultiUserActivationSubject"
                        [showBluechatColumns]="true"
                        [showRegions]="true"
                        [filtersComponent]="dataFilters"
                        [(filters)]="filters"
                        (filtersReset)="filters.reset()"
                        [showEdit]="false"
                        [showActionsColumn]="true"
                        [actionsColumn]="actionsColumn">
                    </app-user-table>
                </div>
            </div>
        </div>
    </div>

    <ng-template #actionsColumn let-user="user">
        <dropdown-actions>
            <div class="dropdown-item">
                <button class="btn btn-info btn-sm m-r-xs" (click)="goToEditChepManager(user.id)"
                        [i18n]="[{target: 'attribute:title', key: 'user-dashboard.users.chep-manager.actions.edit'}]">
                    <span>
                        <i class="fa fa-user-edit"></i>&nbsp;
                        <span [i18n]="'user-dashboard.users.chep-manager.actions.edit'"></span>
                    </span>
                </button>
            </div>
            <div class="dropdown-item">
                <button class="btn btn-info btn-sm m-r-xs" (click)="goToCreateDuplicateChepManager(user)"
                        [i18n]="[{target: 'attribute:title', key: 'user-dashboard.users.chep-manager.actions.duplicate'}]">
                    <span>
                        <i class="fa fa-user-plus"></i>&nbsp;
                        <span [i18n]="'user-dashboard.users.chep-manager.actions.duplicate'"></span>
                    </span>
                </button>
            </div>
        </dropdown-actions>
    </ng-template>
</section>
